"use strict";

var ModalId = /* @__PURE__ */(ModalId2 => {
  ModalId2["Support"] = "support";
  ModalId2["Account"] = "account";
  ModalId2["Cart"] = "cart";
  ModalId2["CartPreview"] = "cartPreview";
  ModalId2["Language"] = "language";
  ModalId2["MobileMenu"] = "mobileMenu";
  ModalId2["ProMobileMenu"] = "proMobileMenu";
  ModalId2["Search"] = "search";
  return ModalId2;
})(ModalId || {});
var SiteConfigType = /* @__PURE__ */(SiteConfigType2 => {
  SiteConfigType2["Basic"] = "basic";
  SiteConfigType2["Regional"] = "regional";
  return SiteConfigType2;
})(SiteConfigType || {});
export { ModalId, SiteConfigType };
//# sourceMappingURL=types.mjs.map
